import { Pipe, PipeTransform } from '@angular/core';
import { adminToHebrewName as adminTypeToHebrewName } from '../Interfaces/users';
import { adminToHebrewName as likutAdminToHebrewName } from '../services/likut.service';
import { adminToHebrewName as truckLoadingAdminToHebrewName } from '../services/truck-loading.service';

@Pipe({
	name: 'adminToHebrewName',
})
export class AdminToHebrewNamePipe implements PipeTransform {
	transform(value: unknown): unknown | string {
		if (typeof value !== 'string') return value;
		if (likutAdminToHebrewName[value]) return likutAdminToHebrewName[value];
		if (truckLoadingAdminToHebrewName[value]) return truckLoadingAdminToHebrewName[value];
		if (adminTypeToHebrewName[value]) return adminTypeToHebrewName[value];
		return value;
	}
}
